import React from 'react';
import { useFi } from '../../contexts/fi-context';
import { AssistantPanelHeader } from '../assistant-widget/assistant-panel-header';
import { FiBlobAvatar } from './fi-blob-avatar';

/** Fi panel header: shared chrome + Fi blob avatar. */
export const FiHeader: React.FC = () => {
  const { closePanel } = useFi();

  const avatarSlot = (
    <div className="flex min-w-0 items-center gap-2">
      <FiBlobAvatar size={30} />
      <p className="font-albert-sans min-w-0 truncate text-sm font-semibold text-gray-900">Fi</p>
      <span className="font-open-sans text-muted-text-gray hidden truncate text-xs sm:inline">
        &middot; Your Kindly Human Concierge
      </span>
    </div>
  );

  return <AssistantPanelHeader mode="chat" avatarSlot={avatarSlot} onClose={closePanel} />;
};
